import { useEffect } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { return_google_auth, get_current_user } from "./redux/actions";
import MainPage from "./pages/mainPage";
import LoginRegistration from "./pages/loginRegistration";
import NavBar from "./pages/navBar";
import Footer from "./pages/footer";
import "./App.css";
import PrivateRoute from "./pages/privateRoute";
import NewArticle from "./pages/newArticle";
import SinglePageArticle from "./pages/singlePageArticle";
import AboutUs from "./pages/aboutUs";
import LoggedInUserInfo from "./pages/userInfo";
import UserInfoFromLogout from "./pages/userInfo/userInfoFromLogout";
import TagPosts from "./pages/tagPosts";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(return_google_auth(localStorage.getItem("jwt")));
    dispatch(get_current_user("get", `${process.env.REACT_APP_URL}/api/user`));
  });

  return (
    <BrowserRouter>
      <NavBar />
      <Route exact path="/" component={MainPage} />
      <Route exact path="/loginsignup" component={LoginRegistration} />
      <PrivateRoute exact path="/newArticle" component={NewArticle} />
      <Route exact path="/article/:slug" component={SinglePageArticle} />
      <Route exact path="/aboutUs" component={AboutUs} />
      <Route exact path="/userInfo" component={LoggedInUserInfo} />
      <Route exact path="/user/:id" component={UserInfoFromLogout} />
      <Route exact path="/tags/post/:tag" component={TagPosts} />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
